import React, { Component, PropTypes } from 'react';

import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/immutable';
import Input from 'components/Input/Input';

import './FormInputWithValidation.scss';

export default class FormInputWithValidation extends Component {
  static propTypes = {
    input: PropTypes.shape(fieldInputPropTypes).isRequired,
    meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    placeholder: null,
  };

  render() {
    const { input, meta, placeholder } = this.props;
    const { touched, error } = meta;

    const showValidationError = error && touched;

    return (
      <div className="form-input-with-validation">
        <Input {...input} invalid={showValidationError} placeholder={placeholder} />
        {
          showValidationError && (
            <div className="form-input-with-validation__message">{error}</div>
          )
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Form/FormInputWithValidation.jsx
 **/